import CardVisit from "./cardVisit";

export default function VisitSection() {
  return (
    <section
      id="Kunjungan"
      className="w-full flex flex-col mt-40 md:mt-0 scroll-mt-28"
    >
      <h3 className="text-primary-800 text-2xl font-semibold mb-3 text-center">
        Kunjungan Kerja Tamu
      </h3>
      <p className="text-center">
        Mencatat dan memantau kunjungan kerja tamu di DPRD Kabupaten Penukal
        Abab Lematang Ilir
      </p>
      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-5">
        <CardVisit
          title="Kunjungan"
          desc="Pencatatan kunjungan tamu ke DPRD Kabupaten PALI secara mudah dan dan terintegrasi. Data kunjungan akan tersimpan ke tujuan sebagai pertimbangan kunjungan yang akan datang"
          href="/visit"
          barcodeName="Barcode-Kunjungan"
        />
        <CardVisit
          title="Audiensi"
          desc="Audiensi digunakan untuk mengajukan pertemuan resmi dengan pimpinan atau anggota DPRD Kabupaten Pali. Masyarakat, organisasi, maupun instansi dapat menyampaikan permohonan audiensi dengan melampirkan informasi penting terkait audiensi"
          href="/audiensi"
          barcodeName="Barcode-Audiensi"
        />
      </div>
    </section>
  );
}
